import * as React from 'react';

import { AccordionItemInterface } from '../../interfaces';

import { Container, StyledAccordionItem } from './accordionGroup.styled';
import { AccordionGroupProps } from './accordionGroup.types';

export const AccordionGroup: React.FC<AccordionGroupProps> = (props: AccordionGroupProps): JSX.Element => {
  const { accordionItems, className }: AccordionGroupProps = props;

  return (
    <Container className={className}>
      {accordionItems.map((item: AccordionItemInterface): JSX.Element => (
        <StyledAccordionItem title={item.title} content={item.content} key={item.title} />
      ))}
    </Container>
  );
};
